import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-rose-100/40 via-purple-50/30 to-white">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-200/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-rose-200/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-6 py-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main content */}
          <div className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 bg-gradient-to-r from-purple-600 via-rose-500 to-purple-600 bg-clip-text text-transparent leading-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
              Hi, This is my Portfolio!
            </h1>
            
            <p className="text-2xl md:text-3xl text-gray-700 mb-4 font-light" style={{ fontFamily: '"Lora", serif' }}>
              Creative Portfolio — Clorentia Sherly
            </p>
            
            <p className="text-lg md:text-xl text-gray-600 mb-12 italic max-w-2xl mx-auto">
              "Between words and strategy, I build stories that matter."
            </p>

            <button 
              onClick={scrollToContact}
              className="group relative inline-flex items-center justify-center px-10 py-4 text-lg font-semibold text-white bg-gradient-to-r from-purple-600 to-rose-500 rounded-full overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <span className="relative z-10">Hire Me</span>
              <div className="absolute inset-0 bg-gradient-to-r from-rose-500 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>

          {/* Scroll indicator */}
          <div className={`mt-20 transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            <div className="flex flex-col items-center animate-bounce cursor-pointer">
              <span className="text-sm text-gray-500 mb-2">Scroll to explore</span>
              <i className="ri-arrow-down-line text-2xl text-purple-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
